<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div class="reg-dash-board-tab-wrap relative">
    <div class="settings-registration" style="position: absolute;
    right: 0;
    top: 0;">
      <vs-button @click="getRegFormConfig" color="primary" type="filled" icon-pack="feather" icon="icon-settings"></vs-button>      
    </div>
    <vs-tabs alignment="center" v-model="activeTab">
      <vs-tab label="OVERVIEW">
        <div class="tab-text mt-4">
          <div id="dashboard-analytics">
            <div class="vx-row" ref="counts">
              <!-- CARD 1: CONGRATS -->
              <div
                class="vx-col w-full mb-base adjust-card"
                v-if="totalRegistrations > 0"
              >
                <vx-card title="Registration Analytics">
                  <div
                    class="vx-row "
                  >
                    <!-- LEFT COL -->
                    <div
                      class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col justify-between"
                    >
                      <div>
                        <h2 class="mb-1 font-bold">
                         Total {{ totalRegistrations | k_formatter }} Registrations
                        </h2>
                      </div>
                    </div>

                    <!-- RIGHT COL -->
                    <div
                      class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base"
                    >
                      <!-- <change-time-duration-dropdown class="self-end" /> -->
                      <vs-dropdown vs-trigger-click class="cursor-pointer self-end">
                        <small
                          class="flex cursor-pointer w-32"
                        >
                          <span>{{lastRegistrationDays == 365 ? 'All days' : 'Last '+lastRegistrationDays+' days' }}</span>
                          <feather-icon
                            icon="ChevronDownIcon"
                            svgClasses="h-4 w-4"
                            class="ml-1"
                          />
                        </small>
                        <vs-dropdown-menu class="dropdown-width">
                          <vs-dropdown-item @click="changeRegCountDuration(365)">
                            <span>All Days</span>
                          </vs-dropdown-item>
                          <vs-dropdown-item @click="changeRegCountDuration(30)">
                            <span>Last 30 Days</span>
                          </vs-dropdown-item>
                          <vs-dropdown-item @click="changeRegCountDuration(7)">
                            <span>Last 7 Days</span>
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </div>
                  </div>
                  <vs-divider class="my-6"></vs-divider>
                  <vs-tabs>
                    <vs-tab
                      label="By Registration Type"
                      icon-pack="feather"
                      icon="icon-calendar"
                      v-if="regtypeFlg == true"
                    > 
                      <vue-apex-charts 
                        height="350"
                        type="bar"
                        :series="regTypeSeries"
                        :options="regtypeInfoOptions"
                      ></vue-apex-charts>
                    </vs-tab>
                    <vs-tab
                      label="By Country"
                      icon-pack="feather"
                      icon="icon-map"
                      v-if="countryFlg == true"
                    >
                      <chartjs-component-bar-chart
                        :height="100"
                        :data="regCountryData"
                        :options="regCountryoptions"
                      ></chartjs-component-bar-chart>
                    </vs-tab>
                    <vs-tab
                      label="By Device type"
                      icon-pack="feather"
                      icon="icon-cpu"
                      v-if="deviceInfoFlg == true"
                    >
                      <chartjs-component-bar-chart
                        :height="100"
                        :data="regDeviceInfoData"
                        :options="regDeviceInfoOptions"
                      ></chartjs-component-bar-chart>
                    </vs-tab>
                    <vs-tab
                      label="Free/Paid"
                      icon-pack="feather"
                      icon="icon-airplay"
                      v-if="formtypeFlg == true"
                    >
                      <chartjs-component-bar-chart
                        :height="100"
                        :data="formTypeData"
                        :options="formTypeOptions"
                      ></chartjs-component-bar-chart>
                    </vs-tab>
                    <vs-tab
                      label="By Date"
                      icon-pack="feather"
                      icon="icon-calendar"
                      v-if="dateFlg == true"
                    >
                      <chartjs-component-bar-chart
                        :height="100"
                        :data="regDateInfoData"
                        :options="regDateInfoOptions"
                      ></chartjs-component-bar-chart>
                    </vs-tab>            
                  </vs-tabs>
                </vx-card>
              </div>
              <div
                class="vx-col w-full mb-base adjust-card"
                v-else-if="totalRegistrations == 0"
              >
                <vx-card title="Registration Analytics">
                  <div
                    class="vx-row"
                  >
                        <div slot="no-body" class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
                          <span
                            >No Registrations In Last {{lastRegistrationDays}} days, click View Details to see
                            more</span
                          >     
                          <vs-button
                        icon-pack="feather"
                        icon="icon-chevrons-right"
                        icon-after
                        class="shadow-md  mt-4 mouse-pointer"
                        @click='$router.push("/event/attendees")'
                        >View Details</vs-button
                      >             
                        </div>
                      <div class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
                        <vs-dropdown vs-trigger-click class="cursor-pointer self-end">
                          <small
                            class="flex cursor-pointer w-32"
                          >
                            <span>{{lastRegistrationDays == 365 ? 'All' : 'Last '+lastRegistrationDays+' days' }}</span>
                            <feather-icon
                              icon="ChevronDownIcon"
                              svgClasses="h-4 w-4"
                              class="ml-1"
                            />
                          </small>
                          <vs-dropdown-menu class="dropdown-width">
                            <vs-dropdown-item @click="changeRegCountDuration(365)">
                              <span>All Days</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changeRegCountDuration(30)">
                              <span>Last 30 Days</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changeRegCountDuration(7)">
                              <span>Last 7 Days</span>
                            </vs-dropdown-item>
                          </vs-dropdown-menu>
                        </vs-dropdown>
                      </div>              

                  </div>
                  <vs-divider class="my-6"></vs-divider>
                </vx-card>
              </div>
            </div>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="REG BUILDER">
        <div class="tab-text mt-6">
          <div class="vx-row">
            <div class="vx-col w-full w-12/12 mb-base" align="right">
              <div class="table-upper-head flex justify-between items-center">
                <h4>Registration Types</h4>
                <vs-button class="mb-1" size="small" color="primary" type="filled" icon="add" @click="addRegistrationType"
                  >Add New Registration Type</vs-button>
              </div>
              <div class="flex flex-wrap">
                <div class="flex-grow">
                  <div>
                    <vs-table :data="RegistrationTypes">
                      <template slot="thead">
                        <vs-th>Registration Type</vs-th>
                        <vs-th>Payment Type</vs-th>
                        <vs-th>Price</vs-th>
                        <vs-th>Avl. Qty</vs-th>
                        <!-- <vs-th>Min Limit</vs-th> -->
                        <vs-th>Limit</vs-th>
                        <vs-th>Sale Start Date</vs-th>
                        <vs-th>Sale End Date</vs-th>
                        <vs-th>Status</vs-th>
                        <vs-th>Action</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td :data="data[indextr].RegistrationType">{{
                            data[indextr].RegistrationType
                          }}</vs-td>
                          <vs-td>{{  tr.FormType ? tr.FormType : 'FREE'  }}</vs-td>
                          <vs-td class="text-right">{{tr.Currency && tr.Price ? tr.Currency.symbol : ''}} {{  tr.Price ? parseFloat(tr.Price).toFixed(2) : '0.00'  }}</vs-td>
                          <vs-td class="text-right">{{  tr.Quantity ? tr.Quantity : null  }}</vs-td>
                          <!-- <vs-td>{{  tr.MinLimit ? tr.MinLimit : 1  }}</vs-td> -->
                          <vs-td class="text-center">{{  tr.MinLimit ? tr.MinLimit : 1  }} 
                          {{tr.MinLimit == tr.MaxLimit ? '' : 'to' }} 
                          {{  tr.MaxLimit && tr.MinLimit != tr.MaxLimit ? tr.MaxLimit : ''  }}</vs-td>
                          <vs-td>{{  tr.SaleStartDate | formatDate }}</vs-td>
                          <vs-td>{{  tr.SaleEndDate | formatDate }}</vs-td>
                          <vs-td :data="data[indextr].IsPublished">
                            <vs-switch v-model="data[indextr].IsPublished" @input="changeRegTypesStatus(data[indextr].IsPublished, tr.RegistrationTypeId)"/>                    
                          </vs-td>
                          <vs-td :data="data[indextr].RegistrationTypeId">
                            <feather-icon
                              icon="Edit3Icon"
                              title="Edit Admin"
                              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                              @click="editRegistrationType(data[indextr].RegistrationTypeId)"
                            />
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </div>
            </div>            
            <div class="vx-col w-8/12 mb-base" v-if="GeneralSettings" align="right">
              <div class="table-upper-head flex justify-between items-center">
                <h4>Checkout Forms</h4>
                <vs-button v-if="GeneralSettings.RegistrationVersion==3" class="mb-1" size="small" color="primary" type="filled" icon="add" @click='$router.push("/event/addcheckoutform")'
                  >Add New Checkout Form</vs-button
                >
                <vs-button v-else :disabled="regforms.length<=0 ? false : true" class="mb-1" size="small" color="primary" icon="add" @click='$router.push("/event/registrationform")'
                  >Add New Registration Form</vs-button
                >
              </div>
              <div class="flex flex-wrap" style="min-height: 400px">
                <div class="flex-grow">
                  <div>
                    <vs-table :data="regforms">
                      <template slot="thead">
                        <vs-th>Form Name</vs-th>
                        <vs-th>{{GeneralSettings.RegistrationVersion==3 ? 'Mapped Registration Types': 'Form Type'}}</vs-th>
                        <vs-th>Status</vs-th>
                        <vs-th>Action</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td :data="data[indextr].FormTitle">{{
                            data[indextr].FormTitle
                          }}</vs-td>
                          <vs-td v-if="GeneralSettings.RegistrationVersion!=3">{{
                            data[indextr].FormType
                          }}</vs-td>
                          <vs-td v-if="GeneralSettings.RegistrationVersion==3">{{
                            data[indextr].RegistrationTypes.map(row=>{
                              return row.RegistrationType
                            }).toString() | 'NA'
                          }}</vs-td>
                          <vs-td :data="data[indextr].IsPublished">
                            <vs-switch v-model="data[indextr].IsPublished" @input="changeCheckoutFormsStatus(data[indextr].IsPublished, tr.FormId)"/>                    
                          </vs-td>
                          <vs-td :data="data[indextr].FormId">
                            <feather-icon
                              icon="Edit3Icon"
                              title="Edit Admin"
                              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                              @click="editRegistrationForm(data[indextr].FormId)"
                            />
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col w-4/12 mb-base mt-6">
              <div
                class="over-right-side-box py-3 over-dark-bg"
                v-if="allowRegistrationFlg == true"
              >
                <div
                  class="d-flex align-items-center over-t-head pb-3 px-4"
                  style="background: #252d3a !important; color: #fff !important"
                >
                  <img
                    src="../../assets/images/registration.svg"
                    class="mr-2"
                    alt=""
                    style="color: white; height: 24px; width: 26px"
                  />
                  Preview &amp; Share link
                </div>
                <span id="custom-tooltip-reg">copied!</span>
                <div class="px-4" style="text-align: center">
                  <p class="over-r-des">
                    Use this link to invite people to this event:
                  </p>
                  <div class="form-group position-relative">
                    <input
                      type="text"
                      class=""
                      placeholder=""
                      :value="newVersionRegLink"
                      readonly
                      id="reglink"
                    />
                    <span
                      class="over-copy"
                      @click="copyLinkRegistration(newVersionRegLink)"
                      ><img src="../../assets/images/overview/copy.svg"
                    /></span>
                  </div>
                  <a
                    :href="newVersionRegLink"
                    target="_blank"
                    style="
                      justify-content: center;
                      align-items: center;
                      display: flex;
                    "
                    >Go to registration page<feather-icon
                      icon="ExternalLinkIcon"
                      svgClasses="w-6 h-6 ml-2"
                    ></feather-icon
                  ></a>

                  <!-- <a
                    href="javascript:void(0)"
                    @click="pushToPage('/event/paidregistrants')"
                    class="paid-reg mt-3"
                    >Paid Registrations
                  </a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="All REGISTRATIONS" v-on:click="$router.push('/event/attendees')">
        <vs-button size="small" @click="$router.push('/event/attendees')">All REGISTRATIONS</vs-button>
      </vs-tab>
      <vs-tab label="PAID REGISTRATIONS" v-on:click="$router.push('/event/paidregistrants')">
        <vs-button size="small" @click="$router.push('/event/paidregistrants')">PAID REGISTRATIONS</vs-button>
      </vs-tab>
      <vs-tab label="PREVIEW">
        <div class="tab-text  preview-web-wrapper-class"> 
          <iframe :src="newVersionRegLink" width="100%" height="500" frameborder="0"></iframe>
        </div>
      </vs-tab>
      
    </vs-tabs>
    <vs-popup class="holamundo reg-config-popup" title="Checkout Form Payment Settings" :active.sync="popupPayingtoLogo">
      <div class="vx-row">
        <div class="vx-col md:w-6/12 w-full mb-10">
          <label>Paying To Logo </label>
          <div class="paying-logo-wrap flex">
            <div class="paying-logo-image-wrap">
              <img :src="regFormConfig.PayingToLogo" class="" />
            </div>
            <div class="ml-3">
              <!-- <p class="text-lg font-medium"></p> -->
              <input
                id="uploadAvatar"
                type="file"
                class="hidden"
                ref="update_avatar_input"
                @change="update_avatar($event, 'PayingToLogo', '960x192', false)"
                accept="image/*"
              />
              <vs-button
                class="mr-4 mb-4"
                @click="$refs.update_avatar_input.click()"
                >Upload</vs-button
              ><br/>(recommended image dimension 960/192)
            </div>
          </div>
        </div>
        <div class="vx-col md:w-6/12 w-full mb-10">
          <label>Registration Form Side Banner</label>
          <div class="paying-logo-wrap flex">
            <div class="paying-logo-image-wrap">
              <img :src="regFormConfig.RegFormSideBanner" class="" />
            </div>
            <div class="ml-3">
              <input
                type="file"
                class="hidden"
                ref="update_banner_input"
                @change="update_banner($event, 'RegFormSideBanner')"
                accept="image/*"
              />
              <vs-button
                class="mr-4 mb-4"
                @click="$refs.update_banner_input.click()"
                >Upload</vs-button
              >
              <vs-button
                color="danger" type="gradient" icon="delete"
                class="mr-4 mb-4"
                @click="regFormConfig.RegFormSideBanner=null"
                ></vs-button
              >
            </div>
          </div>
        </div>
        <div class="vx-col md:w-6/12 w-full">
          <div class="submitbutton-label">
            <label class="w-full">Submit Button Display Label </label>
            <vs-input
              class="w-full"
              name="SubmitButtonDisplaylabel"
              v-model="regFormConfig.SubmitButtonDisplaylabel"
              data-vv-as="Submit Button Display Label"
            />
          </div>
        </div>

        <div class="vx-col md:w-6/12 w-full">
          <div class="textbox-beside-wrap paying-top-client-wrap">
            <label>Paying To </label>
            <vs-input
              class="w-full"
              name="PayingTo"
              v-model="regFormConfig.PayingTo"
              data-vv-as="Submit Button Display Label"
            />
          </div>
        </div>
        
        <div class="vx-col md:w-6/12 w-full">
          <div class="textbox-beside-wrap">
            <vs-checkbox class="mt-3" v-model="regFormConfig.LandingPageShowHostedByPanel"
              >Show Landing Page Hosted By Panel</vs-checkbox
            >
          </div>
        </div>
        <div class="vx-col md:w-6/12 w-full">
          <div class="textbox-beside-wrap">
            <vs-checkbox class="mt-3" v-model="regFormConfig.LandingPageShowEventListLink"
              >Show Landing Page Event List Link</vs-checkbox
            >
          </div>
        </div>
        <div class="vx-col md:w-12/12 w-full mb-5 mt-5">
          <div class="textbox-beside-wrap">
            <label>Add Payment Gateway</label>
            <div class="paying-logo-wrap flex">
              <vs-switch class="mt-0" v-model="regFormConfig.isPaymentGatewayEnabled"/>
            </div>
          </div>
        </div>
        <div class="vx-col md:w-12/12 w-full mb- mt-5" v-if="regFormConfig.isPaymentGatewayEnabled">



          <label>Select a Payment Gateway</label>
  
         <v-select
         placeholder="Select a Gateway"
          class="mt-4"
          :options="paymentGateways"
          v-model="regFormConfig.paymentGateway"
          name="paymentGateway"
        />
        </div>
        <div class="vx-col md:w-12/12 w-full mb-0 mt-5" v-if="regFormConfig.isPaymentGatewayEnabled">
          <div class="textbox-beside-wrap">
            <label>Enabled Test Mode </label>
            <div class="paying-logo-wrap flex">
              <vs-switch class="mt-0" v-model="regFormConfig.isTestModeEnabled"/>
            </div>
          </div>
        </div>
        <div class="vx-col md:w-6/12 w-full mt-3" v-if="regFormConfig.isPaymentGatewayEnabled && regFormConfig.paymentGateway">
          <div class="publish-key-hld">
            <label>Test Publishable Key </label>
            <vs-input
              class="w-full"
              name="TestPublishableKeyDisplaylabel"
              v-model="regFormConfig.TestPublishableKey"
              data-vv-as="Test Publishable Key"
            />
          </div>
        </div>
        
        <div class="vx-col md:w-6/12 w-full mt-3" v-if="regFormConfig.isPaymentGatewayEnabled && regFormConfig.paymentGateway">
          <div class="publish-key-hld">
            <label>Live Publishable Key </label>
            <vs-input
              class="w-full"
              name="LivePublishableKeyDisplaylabel"
              v-model="regFormConfig.LivePublishableKey"
              data-vv-as="Live Publishable Key"
            />
          </div>
        </div>
        
        <div class="vx-col md:w-6/12 w-full mt-3" v-if="regFormConfig.isPaymentGatewayEnabled && regFormConfig.paymentGateway">
          <div class="test-secret-key-wrap">
            <label>Test Secret Key</label>
            <vs-input
              class="w-full"
              name="TestSecretKeyDisplaylabel"
              v-model="regFormConfig.TestSecretKey"
              data-vv-as="Test Secret Key"
            />
          </div>
        </div>
           <div class="vx-col md:w-6/12 w-full mt-3" v-if="regFormConfig.isPaymentGatewayEnabled && regFormConfig.paymentGateway">
          <div class="live-text-field">
            <label>Live Secret Key</label>
            <vs-input
              class="w-full"
              name="LiveSecretKeyDisplaylabel"
              v-model="regFormConfig.LiveSecretKey"
              data-vv-as="Live Secret Key"
            />
          </div>
          </div>


        <div class="vx-col md:w-6/12 w-full mt-3" v-if="regFormConfig.isPaymentGatewayEnabled && regFormConfig.paymentGateway">
          <div class="test-secret-key-wrap">
            <label>Test Signing Secret</label>
            <vs-input
              class="w-full"
              name="TestSigningSecretDisplaylabel"
              v-model="regFormConfig.TestSigningSecret"
              data-vv-as="Test Signing Secret"
            />
          </div>
          </div>

             <div class="vx-col md:w-6/12 w-full mt-3" v-if="regFormConfig.isPaymentGatewayEnabled && regFormConfig.paymentGateway">
          <div class="live-text-field">
            <label>Live Signing Secret</label>
            <vs-input
              class="w-full"
              name="LiveSigningSecretDisplaylabel"
              v-model="regFormConfig.LiveSigningSecret"
              data-vv-as="Live Signing Secret"
            />
          </div>
          </div>



        <div class="flex justify-end w-full mx-3 mt-5">
          <vs-button size="small" @click="setRegFormConfig">SAVE</vs-button>
        </div>            
      </div>
    </vs-popup>
    <vs-popup class="holamundo customnewpopup" :title="`${ticket_data && ticket_data.RegistrationTypeId ? 'Edit' : 'Add'} Registration Type`" :active.sync="popupTicketPopup">
      <vx-card v-if="ticket_data">
        <ticket-edit-tab-info :data="ticket_data" v-on:reloadGrid="reloadGrid" />
      </vx-card>
    </vs-popup>
    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      fullscreen="fullscreen"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
  </div>
  
</template>

<script>
import vSelect from "vue-select";
import VueApexCharts from "vue-apexcharts";
import moment from "moment-timezone";
import analyticsData from "../ui-elements/card/analyticsData.js";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ChartjsComponentBarChart from "../charts-and-maps/charts/chartjs/charts-components/ChartjsComponentBarChart.vue";
// Store Module
import moduleDashboardManagement from "@/store/dashboard/moduleDashboard.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleTicketManagement from "@/store/ticket-management/moduleTicketManagement.js";
//import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
import ls from "@/common/localStorage";
import TicketEditTabInfo from "@/views/ticket/TicketEditTabInfo.vue";
var vm;
var cn = ls.getSessionEventCollectionName();
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
export default {
  data() {
    return {
      paymentGateways:['Stripe','PayPal'],
      activeTab: 0,
      totalRegistrations: null,
      countryFlg: null,
      analyticsData,
      registrationDetails: [],
      regCountryData: {},
      regCountryoptions: {},
      regDeviceInfoData: {},
      regDeviceInfoOptions: {},
      deviceInfoFlg: null,
      formTypeData: {},
      formTypeOptions: {},
      formtypeFlg: null,
      dateFlg: null,
      regDateInfoData: {},
      regDateInfoOptions: {},
      regtypeFlg: null,
      regTypeSeries: [],
      regtypeInfoData: {},
      regtypeInfoOptions: {},
      lastRegistrationDays: 365,
      popupActiveRTF: false,
      RegistrationTypes: [],
      RegistrationTypeDetail: {
        RegistrationTypeId: null,
        RegistrationType: null,
        ColorCode: "#ffffff00",
      },
      popupPayingtoLogo: false,
      regforms: [],
      popupTicketPopup: false,
      ticket_data: null,
      GeneralSettings: {RegistrationVersion:1},
      allowRegistrationFlg: true,
      registrationLink: `https://${ls.getSessionValueByKey("CustomDomain")}/event/${ls.getSessionValueByKey("Session_Event_Id")}`,
      regFormConfig: {
        PayingToLogo: ls.getSessionValueByKey('ClientLogo'),
        RegFormSideBanner: null,
        SubmitButtonDisplaylabel: 'SUBMIT',
        PayingTo: ls.getSessionValueByKey('ClientName'),
        LandingPageShowHostedByPanel: true,
        LandingPageShowEventListLink: true,
        LivePublishableKey:'',
        TestPublishableKey:'',
        isPaymentGatewayEnabled: false,
        paymentGateway:'',
        isTestModeEnabled: false,
        TestSecretKey:'',
        TestSigningSecret:'',
        LiveSecretKey:'',
        LiveSigningSecret:''
      },



      imageRatio: 5 / 2,
      cropImageUrl: null,
      popupCropper: false,
      resetCropper: 0,
      displayImageRatio: "5 / 2",
      uploadedFile: null,
      uploadedFileKey: null
    };
  },
  computed: {
    newVersionRegLink(){
      let registrationLink = this.registrationLink;
      if(this.GeneralSettings.RegistrationVersion == 3){
        let version = Number(this.GeneralSettings.RegistrationVersion);
        return registrationLink.replace("event", "eventv"+version);
      }else{
        return registrationLink;
      }
    },    
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChartjsComponentBarChart,
    TicketEditTabInfo,
    PhotowallResizeComponent,
    vSelect
  },
  filters:{
    RegistrationTypesNames: function(val){
      if (!val) return ''
      /*if(val.length){
        let names =  val.map(row=>{
          return row.RegistrationType
        })
        return names.toString()
      } else*/ return 'NA'
    },
    formatDate: function(val){
      if (!val) return ''
      return moment(new Date(val._seconds * 1000)).format("MMM DD, YYYY hh:mm A")      
    },
  },
  methods: {
    onScroll() {
    },
    changeRegTypesStatus(value, RegistrationTypeId){
      this.$vs.loading();
      this.$store.dispatch("TicketManagement/editDBRegistrationType", {'IsPublished':value ? true : false,'id':RegistrationTypeId}).then(res=>{
        this.$vs.loading.close();
        this.registrationTypes();
      })
    },    
    changeCheckoutFormsStatus(value, FormId){
      this.$vs.loading();
      this.$store.dispatch("TicketManagement/updatecheckoutFormRandomField", {'IsPublished':value ? true : false,'id':FormId}).then(res=>{
        this.$vs.loading.close();
        this.getRegistrationForms();
      })
    },
    copyLinkRegistration(data) {
      // $("#reglink").val(data);
      var ct = document.getElementById("reglink");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("custom-tooltip-reg").style.display = "inline";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("custom-tooltip-reg").style.display = "none";
      }, 1000);
    },
    changeRegCountDuration(data) {
      //alert("no of days===", data);
      this.lastRegistrationDays = data;
      this.fetchRegistraionCount();
    },
    fetchRegistraionCount() {
      this.$vs.loading();
      this.$store
        .dispatch("dashboardManagement/fetchRegistrationCountDetails", this.lastRegistrationDays)
        .then((res) => {
          this.$vs.loading.close();
          this.registrationDetails = res.data;
          this.totalRegistrations = res.data[0].TotalRegistrations;
          /*this.totalFreeRegistrations = res.data[0].freecount;
          this.totalPaidRegistrations = res.data[0].paidcount;
          this.totalUnPaidRegistrations = res.data[0].unpaidcount;*/
          this.allTotalRegistrations =
            res.data[0].freecount +
            res.data[0].paidcount +
            res.data[0].unpaidcount;
          this.formTypeData = res.data[0].data;
          this.formTypeOptions = res.data[0].options;
          this.formtypeFlg = res.data[0].formtypeFlg;

          this.regCountryData = res.data1[0].data;
          this.regCountryoptions = res.data1[0].options;
          this.countryFlg = res.data1[0].countryFlg;
          this.regDeviceInfoData = res.data2[0].data;
          this.regDeviceInfoOptions = res.data2[0].options;
          this.deviceInfoFlg = res.data2[0].deviceFlg;

          this.dateFlg = res.data3[0].dateFlg;
          this.regDateInfoData = res.data3[0].data;
          this.regDateInfoOptions = res.data3[0].options;

          this.regtypeFlg = res.data4[0].regtypeFlg;
          this.regtypeInfoData = res.data4[0].data;
          this.regTypeSeries = res.data4[0].series;
          this.regtypeInfoOptions = res.data4[0].options;
        })
        .catch((err) => {
          this.$vs.loading.close();
          console.error(err);
        });
    },

    fetch_ticket_data(RegistrationTypeId) {
      this.ticket_data = null;
      this.$vs.loading();
      this.$store.dispatch("TicketManagement/fetchRegistrationType", RegistrationTypeId)
        .then(res => {
          this.$vs.loading.close();
          if(res.data.RegistrationTypeId){
            this.ticket_data = res.data;
            this.popupTicketPopup = true;
          }
          else if(RegistrationTypeId == null){
            this.ticket_data = res.data;
            this.popupTicketPopup = true;
          }
          else
          {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                //title: "Ticket",
                text: "Registartion Type not found in Registartion JSON!",
              });
          }
          
        })
    },
    reloadGrid(){
      this.popupTicketPopup = false;
      this.ticket_data = null;
      this.registrationTypes();
    },
    addRegistrationType() {
      /*vm.popupActiveRTF = true;
      this.RegistrationTypeDetail = {
        RegistrationTypeId: null,
        RegistrationType: null,
        ColorCode: "#ffffff00",
      };*/
      this.fetch_ticket_data(null);
    },
    editRegistrationType(RegistrationTypeId) {
      this.fetch_ticket_data(RegistrationTypeId);
    },
    registrationTypes() {
      vm.$vs.loading();
      vm.$store
        .dispatch("TicketManagement/fetchRegistrationTypes")
        .then((res) => {
          vm.RegistrationTypes = res.map(item=>{
           item.IsPublished ? true : false
           return item;
         });
          vm.$vs.loading.close();
        });
    },
    getRegistrationForms(){
      if(this.GeneralSettings.RegistrationVersion == 3){
        this.$store.dispatch("TicketManagement/fetchCheckoutForms").then(res=>{
          this.regforms = res
        })
      }else{
        this.$store.dispatch("attendeeManagement/fetchRegistrationForms").then(res=>{
          this.regforms = res
        })
      }
    },
    editRegistrationForm(id){
      console.log(id)
      if(this.GeneralSettings.RegistrationVersion==3){
        this.$router.push({ 
          name: 'edit-checkoutform', 
          params: {FormId: id } 
        })
      }else{
        this.$router.push({ 
          name: 'regform-edit', 
          params: {FormId: id } 
        })
      }
    },
    fetchGeneralSettings(){
      return new Promise((resolve, reject) => {
        // this.$store.dispatch("mailtplManagement/fetchGeneralSettings").then(res=>{
        //   this.GeneralSettings = res;
        //   resolve(true)
        // })
        this.$store.dispatch("eventManagement/fetchEvent", ls.getSessionValueByKey("Session_Event_Id")).then(res=>{
          this.GeneralSettings = res.data;
          resolve(true)
        })
      })
    },
    croppedImagePath(blob) {
      //this.imgSrc = blob;
      this.popupCropper = false;
      if (this.uploadedFile)
        vm.uploadImage(blob, `${cn}/Registration/`, this.uploadedFile);
    },
    update_avatar(input, uploadedFileKey, fileWH, checkRatio = false, ) {
      debugger;
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        this.uploadedFile = file;
        this.uploadedFileKey = uploadedFileKey;
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileWH.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            //vm.imgSrc = e.target.result;
            vm.popupPayingtoLogo = false;
            vm.resetCropper += 1;
            vm.cropImageUrl = null;
            vm.cropImageUrl = e.target.result;
            vm.popupCropper = true;
          };
          reader.readAsDataURL(input.target.files[0]);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadImage(fileBlob, target, file) {
      this.$vs.loading();
      this.$store
        .dispatch("TicketManagement/uploadFiles", [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ])
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.length && res.data[0].status == "fulfilled") {
            this.regFormConfig[this.uploadedFileKey] = res.data[0].value.url;
            this.$vs.notify({
              color: "success",
              position: "top-center",
              //title: "Session",
              text: "File uploaded successfully.",
            });
            vm.popupPayingtoLogo = true;
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "File not uploaded!",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            //title: "Session",
            text: "Something went wrong!",
          });
        });
    },
    update_banner(input, uploadedFileKey) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        var metadata = {
          contentType: file.type,
        };

        this.uploadedFileKey = uploadedFileKey;
        

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            //vm.imgSrc = e.target.result;     
            vm.uploadImage(e.target.result, `${cn}/Registration/`, file);       
          };
          reader.readAsDataURL(input.target.files[0]);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    getRegFormConfig(){
      this.$vs.loading();
      this.$store.dispatch("TicketManagement/getRegFormConfig").then(res=>{
        this.$vs.loading.close();
        if(res.status == 200 && res.data){      
          this.regFormConfig.LivePublishableKey = res.data.LivePublishableKey ? res.data.LivePublishableKey :'';
          this.regFormConfig.TestPublishableKey = res.data.TestPublishableKey ? res.data.TestPublishableKey :'';
          this.regFormConfig.isPaymentGatewayEnabled = res.data.isPaymentGatewayEnabled ? res.data.isPaymentGatewayEnabled : false;
          this.regFormConfig.paymentGateway = res.data.paymentGateway ? res.data.paymentGateway : '';
          this.regFormConfig.isTestModeEnabled = res.data.isTestModeEnabled ? res.data.isTestModeEnabled : false;
          this.regFormConfig.TestSecretKey = res.data.TestSecretKey ? res.data.TestSecretKey : '';
           this.regFormConfig.TestSigningSecret = res.data.TestSigningSecret ? res.data.TestSigningSecret : '';
           this.regFormConfig.LiveSecretKey = res.data.LiveSecretKey ? res.data.LiveSecretKey : '';
            this.regFormConfig.LiveSigningSecret = res.data.LiveSigningSecret ? res.data.LiveSigningSecret : '';
        }
        this.popupPayingtoLogo = true;
      }).catch(err=>{
        this.$vs.loading.close();
        this.$vs.notify({
            color: "warning",
            position: "top-center",
            text: "Something went wrong!",
          });
      })
    },
    setRegFormConfig(){
      this.$vs.loading();     
      this.$store.dispatch("TicketManagement/setRegFormConfig", this.regFormConfig).then(res=>{
        this.$vs.loading.close();
        if(res.status == 200){
          this.$vs.notify({
            color: "success",
            position: "top-center",
            text: "Data saved successfully.",
          });
        }else{
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            text: "Data not saved!",
          });
        }
        this.popupPayingtoLogo = false;
      }).catch(err=>{
        this.$vs.loading.close();
        this.$vs.notify({
            color: "warning",
            position: "top-center",
            text: "Something went wrong!",
          });
      })
    }
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener("scroll", this.onScroll);
      this.onScroll(); // needed for initial loading on page
      this.activeTab = this.$route.query.activeTab ? this.$route.query.activeTab : 0;
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  created() {
    vm = this;
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    if (!moduleTicketManagement.isRegistered) {
      this.$store.registerModule("TicketManagement", moduleTicketManagement);
      moduleTicketManagement.isRegistered = true;
    }    
    // if (!moduleMailtplManagement.isRegistered) {
    //   this.$store.registerModule("mailtplManagement", moduleMailtplManagement);
    //   moduleMailtplManagement.isRegistered = true;
    // }
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    if (!moduleDashboardManagement.isRegistered) {
      this.$store.registerModule(
        "dashboardManagement",
        moduleDashboardManagement
      );
      moduleDashboardManagement.isRegistered = true;      
    }
    this.fetchRegistraionCount();
    this.registrationTypes();
    this.fetchGeneralSettings().then(()=>{
      this.getRegistrationForms();
    });
    
  },
};
</script>

<style>
.reg-dash-board-tab-wrap .line-vs-tabs{height: 5px !important;}
</style>
<style lang="scss">
/*! rtl:begin:ignore */
.roundtable-count-hld{
    height: 120px;
    width: 120px;
    margin: 25px auto 0;
    border: 6px solid #55ea86;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.roundtable-count-hld h3 {
    margin: 0;
    font-size: 25px;
    color: #333;
}
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }



  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
  .mouse-pointer {
    cursor: pointer;
  }
  .two-col-special {
    padding: 5;
  }

  .two-col-special li {
    display: inline-block;
    width: 50%;
    padding: 0;
    vertical-align: top;
  }
  span.padd {
    padding-left: 10%;
  }
  .adjust-card {
    display: flex;
  }
  .loader {
    position: absolute;
    left: calc(50% - 35px);
    top: 250%;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 3px solid transparent;
    border-left: 3px solid rgba(121, 97, 249, 1);
    -webkit-animation: rotateOpacity 1s ease infinite 0.2s;
    animation: rotateOpacity 1s ease infinite 0.2s;
  }
  @keyframes rotateOpacity {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
      opacity: 0.1;
    }
    100% {
      -webkit-transform: rotate(1turn);
      transform: rotate(1turn);
      opacity: 1;
    }
  }
}
</style>
